export const de = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Zurück",
        save: "Speichern",
        saved: "Gespeichert",
        cancel: "Abbrechen",
        close: "Schließen",
        accessDenied: "Zugriff verweigert",
        noExportPermission: "Sie haben keine Berechtigung, diese Fahrzeugdaten zu exportieren.",
        delete: "Löschen",
        downgrade: "Downgrade",
        downgradeConfirm: "Sind Sie sicher, dass Sie auf den kostenlosen Plan downgraden möchten?",
        edit: "Bearbeiten",
        loading: "Laden...",
        confirm: "Bestätigen",
        processing: "Wird verarbeitet...",
        history: "Verlauf",
        currentCar: "Aktuelles Auto",
        purchasedCarTitle: "Fahrzeugkauf",
        initialCost: "Anfangskosten",
        done: "Fertig",
        ok: "OK",
        error: "Fehler",
        errorSaving: "Fehler beim Speichern der Daten",
        mandatoryFieldsError: "Bitte füllen Sie alle Pflichtfelder korrekt aus.",
        search: "Suchen",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Ungültiges E-Mail-Format",
        today: "Heute",
        car: "Auto",
        all: "Alle",
        deleteConfirm: "Löschen",
        unsavedChangesTitle: "Ungespeicherte Änderungen",
        unsavedChangesMessage: "Möchten Sie die Änderungen vor dem Verlassen speichern?",
        dontSave: "Nicht speichern",
        additionalOptions: "Weitere Optionen",
        add: "Hinzufügen",
        fileTooLarge: "Datei ist zu groß. Maximale Größe ist {limit} MB.",
        storageFull: "Speicherlimit überschritten. Maximaler Speicher ist {limit} MB.",
        dailyUploadLimit: "Tägliches Upload-Limit erreicht ({limit} Dateien/Tag). Versuche es morgen wieder.",
        hourlyUploadLimit: "Stündliches Upload-Limit erreicht ({limit} Dateien/Stunde). Versuche es in einer Stunde wieder.",
        fileCountLimit: "Maximal {limit} Dateien pro Element erlaubt.",
        emailParseLimitReached: "E-Mail-Parsing-Limit erreicht. Bitte aktualisieren Sie Ihren Plan oder verarbeiten Sie manuell.",
        emailLimitText: "E-Mail-Verarbeitungslimit erreicht.",
        monthlyEmailScans: "Monatliche E-Mail-Scans (Pro)",
        lifetimeEmailScans: "Lebenslange E-Mail-Scans (Kostenlos)",
        monthlyFileScans: "Monatliche Belegscans (Pro)",
        lifetimeFileScans: "Lebenslange Belegscans (Kostenlos)",
        fileLimitText: "Belegscan-Limit erreicht.",
        planFreeTier: "Kostenloses Angebot",
        planProTier: "Pro-Angebot",
        uploadFailed: "Hochladen fehlgeschlagen",
        attachments: "Anhänge",
        limitsAndUsage: "Limits & Nutzung",
        addresses: "Adressen",
        emailCopied: "E-Mail-Adresse kopiert!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Inklusive",
        proOnly: "Nur PRO",
        month: "Monat",
        openInNewTab: "In neuem Tab öffnen",
        menu: "Menü",
        home: "Startseite",
        monthsShort: {
            0: "Jan",
            1: "Feb",
            2: "Mär",
            3: "Apr",
            4: "Mai",
            5: "Jun",
            6: "Jul",
            7: "Aug",
            8: "Sep",
            9: "Okt",
            10: "Nov",
            11: "Dez",
        },
    },
    carMetadata: {
        bodyType: "Karosserieform",
        drivetrain: "Antriebsart",
        transmission: "Getriebe",
        bodyTypes: {
            sedan: "Limousine",
            hatchback: "Schrägheck",
            wagon: "Kombi",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupé",
            convertible: "Cabriolet",
            pickup: "Pickup",
            van: "Van / Minivan",
            commercial: "Gewerblich",
            other: "Andere",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "Vorderradantrieb",
            rwd: "Hinterradantrieb",
            awd: "Allradantrieb / 4x4",
            other: "Andere",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manuell",
            automatic: "Automatisch",
            cvt: "CVT",
            other: "Andere",
        },
        otherLabel: "Andere (bitte angeben)",
        mileageLabel: "Kilometerstand",
    },
    auth: {
        welcome: "Willkommen",
        welcomeBack: "Willkommen zurück",
        signIn: "Anmelden",
        signInWithGoogle: "Mit Google anmelden",
        signOut: "Abmelden",
        magicLinkDesc: "Erhalten Sie einen Magic Link per E-Mail",
        magicLinkSent: "Magic Link gesendet!",
        magicLinkCheckEmail: "Prüfen Sie Ihre E-Mail und klicken Sie auf den Link zum Anmelden.",
        emailAddress: "E-Mail-Adresse",
        getMagicLink: "Magic Link anfordern",
        sending: "Wird gesendet...",
        linkSent: "Link gesendet",
        orContinueWith: "Oder weiter mit",
        googleAccount: "Google-Konto",
        newUserNote: "Neu hier? Ihr Konto wird bei Ihrer ersten erfolgreichen Anmeldung automatisch erstellt.",
        magicLinkError: "Magic Link konnte nicht gesendet werden. Bitte prüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
        genericError: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        projectDescription: "Verfolgen Sie Fahrzeugkosten, Wartung und Verlauf an einem Ort.",
        loginError: "Anmeldung nicht möglich",
        loggingIn: "Anmelden...",
        authenticating: "Authentifizierung...",
        authenticatingDesc: "Bitte warten Sie, während wir Ihre Sitzung sichern.",
    },
    settings: {
        title: "Einstellungen",
        systemPreferences: "Systemeinstellungen",
        appSettings: "App-Einstellungen",
        dangerZone: "Gefahrenzone",
        theme: "Thema",
        language: "Oberflächensprache",
        currency: "Währung",
        units: "Einheiten",
        distanceUnit: "Entfernungseinheit",
        volumeUnit: "Volumeneinheit",
        expenseTypes: "Ausgabetypen",
        expenseTypesDesc: "Kategorien verwalten",
        categories: "Kategorien",
        exportData: "Daten exportieren",
        exportDesc: "Umfassendes CSV herunterladen",
        importData: "Daten importieren",
        importDesc: "Aus CSV-Sicherung wiederherstellen",
        deleteAccount: "Konto löschen",
        deleteAccountDesc: "Alle Daten dauerhaft entfernen",
        enableSync: "Synchronisierung aktivieren",
        enableSyncDesc: "Daten geräteübergreifend synchronisieren",
        account: "Konto",
        accountPlan: "Kontoplan",
        carsUsage: "Autos",
        carsLimitReached: "Auto-Limit erreicht",
        storageSize: "Speichergröße",
        emailScans: "E-Mail-Scans",
        fileScans: "Beleg-Scans",
        plans: "Pläne",
        currentlyPlan: "Aktuell",
        upgradePlan: "Upgrade",
        manageSubscription: "Abonnement verwalten",
        nextPayment: "Nächste Zahlung",
        endsOn: "Endet am",
        adminConsole: "Admin-Konsole",
        systemControl: "Systemsteuerung",
        customCategories: "Benutzerdefinierte Kategorien & Labels",
        interfaceTheme: "Oberflächenthema",
        light: "Hell",
        dark: "Dunkel",
        timezone: "Zeitzone",
        timezoneDesc: "Wird für geplante E-Mail-Erinnerungen verwendet",
        timeFormat: "Zeitformat",
        timeFormat24h: "24-Stunden (14:30)",
        timeFormat12h: "12-Stunden (2:30 PM)",
        kilometers: "Kilometer (km)",
        miles: "Meilen (mi)",
        liters: "Liter (l)",
        gallons: "Gallonen (gal)",
        accountManagement: "Kontoverwaltung",
        contactUs: "Kontakt",
        contactDesc: "Für Vorschläge, Funktionsanfragen und Fragen",
        logOut: "Abmelden",
        logOutConfirmTitle: "Abmelden",
        logOutConfirmMessage: "Sind Sie sicher, dass Sie sich von Ihrem Konto abmelden möchten?",
        keepAccount: "Konto behalten",
        deleteAccountConfirmTitle: "Konto löschen",
        deleteAccountConfirmMessage: "Sind Sie sicher, dass Sie Ihr Konto und alle zugehörigen Fahrzeugdaten dauerhaft löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        deletePermanently: "Dauerhaft löschen",
        deleting: "Wird gelöscht...",
        contactSupport: "Support kontaktieren",
        messageSent: "Nachricht gesendet!",
        feedbackThanks: "Vielen Dank für Ihr Feedback. Wir schätzen Ihren Beitrag und werden ihn prüfen.",
        backToSettings: "Zurück zu Einstellungen",
        subjectLabel: "Betreff",
        messageLabel: "Nachricht",
        subjectPlaceholder: "Worum geht es?",
        messagePlaceholder: "Erzählen Sie uns von Ihrem Vorschlag, Ihrer Funktionsanfrage oder Frage...",
        enterSubjectAlert: "Bitte geben Sie einen Betreff ein",
        enterMessageAlert: "Bitte geben Sie eine Nachricht ein",
        sendFailedAlert: "Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
    },
    export: {
        title: "Daten exportieren",
        generatePDF: "PDF generieren",
        carInformation: "Fahrzeuginformationen",
        editInfo: "Bearbeiten Sie die Informationen unten, um Ihren Export anzupassen",
        editInfoHint: "Sie können alle Felder entfernen oder bearbeiten, die Sie nicht einbeziehen möchten",
        filters: "Filter",
        expenseTypes: "Ausgabetypen",
        includeNotes: "Notizen einbeziehen",
        includeImages: "Dateien einbeziehen",
        hideDisabled: "Deaktivierte Elemente ausblenden",
        itemsCount: "{total} Elemente, {selected} ausgewählt",
        selectAll: "Alle auswählen",
        deselectAll: "Alle abwählen",
        expenses: "Ausgaben",
        notes: "Notizen",
        spareParts: "Ersatzteile",
        images: "Bilder",
        files: "Dateien",
        summary: "Zusammenfassung",
        totalExpenses: "Gesamtausgaben",
        totalItems: "Gesamtelemente",
        generatedOn: "Erstellt am",
        noItemsSelected: "Keine Elemente für den Export ausgewählt",
        noItemsAvailable: "Keine Elemente für den Export verfügbar",
        generating: "PDF wird generiert...",
        downloadPDF: "PDF herunterladen",
        pdfFileName: "{carName}_export_{date}.pdf",
        reportTitle: "Fahrzeugkostenbericht",
        exportButton: "Export",
        generateCSV: "CSV generieren",
        formatSelectorTitle: "Format wählen",
        formatSelectorMsg: "Bitte wählen Sie das Exportformat aus",
        proFeatureExportTitle: "Pro-Funktion: Daten exportieren",
        proFeatureExportDesc: "Upgrade auf PRO, um Ihre Fahrzeughistorie als PDF zu exportieren.",
        exportRestrictedPopup: "Der Datenexport ist nur für Pro-Nutzer verfügbar.",
        allTypes: "Alle Typen",
        statistics: "Statistiken",
        driven: "Gefahren",
        since: "Seit",
        averageCost: "Durchschnittskosten",
        perKm: "pro km",
        perMile: "pro Meile",
        period: "Zeitraum",
        dateFrom: "Von",
        dateTo: "Bis",
        allTime: "Filter zurücksetzen",
        periodHint: "Wenn kein Zeitraum ausgewählt ist — werden alle Ausgaben angezeigt",
        noExpenses: "Keine Ausgaben entsprechen den Filtern",
        expensesSection: "Ausgaben",
        attachmentsSection: "Anhänge",
        imagesCount: "{count} Bilder",
        pdfsCount: "{count} PDFs",
        includeParts: "Ersatzteile einbeziehen",
        pageLabel: "Seite",
    },
    expenses: {
        title: "Ausgaben",
        newExpense: "Neue Ausgabe",
        editExpense: "Ausgabe bearbeiten",
        openExpense: "Aufwandsbuchung öffnen",
        details: "Ausgabendetails",
        selectType: "Typ auswählen",
        selectTypePlaceholder: "Ausgabetyp auswählen...",
        shortDescriptionPlaceholder: "Kurze Beschreibung...",
        expenseTitle: "Titel",
        logEntryTitleLabel: "Titel des Eintrags (optional)",
        defaultTitlePlaceholder: "Standardmäßig - {type}",
        autoTitlePlaceholder: "Wird automatisch basierend auf gewählten Typen gefüllt",
        carDataTitle: "Fahrzeugdaten",
        defaultTitlePrefix: "Der Standardtitel wird -",
        addAnother: "Weitere Ausgabenart hinzufügen",
        addAnotherHint: "Wenn dieser Eintrag mehrere Ausgabenarten enthält, können Sie diese hier alle hinzufügen, um genaue Statistiken zu gewährleisten.",
        carValueDescription: "Optional: Geschätzter Marktwert des Fahrzeugs zu diesem Zeitpunkt.",
        type: "Typ",
        date: "Datum",
        amount: "Betrag",
        totalAmount: "Gesamt",
        splitCosts: "Kosten aufteilen?",
        combineCosts: "Kosten kombinieren",
        amountWork: "Betrag für Arbeit",
        amountParts: "Betrag für Teile",
        mileage: "Kilometerstand",
        carValue: "Fahrzeugwert",
        description: "Beschreibung",
        detailedDescription: "Detaillierte Beschreibung",
        electricity: "Strom",
        fuelType: "Kraftstofftyp",
        fuelTypeOptions: {
            petrol: "Benzin",
            diesel: "Diesel",
            lpg: "LPG",
            electricity: "Elektro",
        },
        carData: "Fahrzeugdaten",
        images: "Dateien",
        addImages: "Dateien hinzufügen",
        addImagesPDFs: "Bilder oder PDFs hinzufügen",
        deleteExpense: "Ausgabe löschen",
        deleteConfirm: "Sind Sie sicher, dass Sie diese Ausgabe löschen möchten?",
        saveSuccess: "Ausgabe erfolgreich gespeichert",
        thisExpense: "Diese Ausgabe",
        stats: {
            annual: "Jährlich",
            allTime: "Gesamt",
            avgMonth: "Ø/Monat",
            costPer: "Kosten/",
            noExpenses: "Noch keine Ausgaben",
            dragToReorder: "Zum Neuanordnen ziehen",
        },
        expensesFound: "Erstellt",
        noExpensesFound: "Keine Ausgaben gefunden.",
        noDescription: "Keine Beschreibung",
        imagesCount: "Bilder ({count})",
        deleteImageTitle: "Bild löschen",
        deleteImageConfirm: "Sind Sie sicher, dass Sie dieses Bild löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        typeLabels: {
            fuel: "Kraftstoff",
            car_wash: "Wäsche",
            repairs: "Reparaturen",
            maintenance: "Wartung",
            parts: "Ersatzteile",
            insurance: "Versicherung",
            inspection: "Inspektion",
            tyres: "Reifen",
            parking: "Parken",
            electricity: "Strom",
            taxes: "Steuern",
            other: "Sonstiges",
            info: "Information",
            service_maintenance: "Wartung",
            service_repair: "Reparatur",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Service",
            selectSubtype: "Serviceart wählen",
            maintenance: "Wartung",
            repair: "Reparatur",
            tuning: "Tuning",
        },
        timeLabel: "Zeit",
        addTimeLabel: "Zeit hinzufügen",
        removeTimeLabel: "Zeit entfernen",
    },
    repeatingExpenses: {
        title: "Wiederkehrende Ausgaben",
        repeatToggle: "Diese Ausgabe wiederholen",
        repeatFrequency: "Häufigkeit",
        monthly: "Monatlich",
        startDate: "Startdatum",
        nextDate: "Nächster Eintrag wird generiert",
        endDate: "Enddatum",
        noEndDate: "Kein Enddatum",
        copyOptions: "Kopieroptionen",
        copyTitle: "Titel des Eintrags kopieren",
        copyLocation: "Standort kopieren",
        copyDescription: "Beschreibung kopieren",
        active: "Aktiv",
        status: "Status",
        managedByRepeat: "Diese Ausgabe ist Teil einer wiederkehrenden Folge.",
        placeholder: "Hier können Sie die automatische Wiederholung für diese Ausgabe einrichten, wenn sie regelmäßig mit dem gleichen Betrag auftritt.",
        deleteRepeat: "Wiederholung löschen",
        deleteRepeatConfirm: "Sind Sie sicher, dass Sie diese wiederkehrende Folge stoppen und löschen möchten? Zukünftige Einträge werden nicht generiert. Vergangene Einträge bleiben erhalten.",
        relatedEntries: "Einträge in dieser Folge",
        stopRepeat: "Wiederholung stoppen",
        isRepeating: "Wiederholend",
        noTerm: "Unbefristet",
        until: "Letzter Eintrag wird generiert",
        summaryCopy: "System wird kopieren",
        simulate: "Nächste Eintragsgenerierung simulieren",
        simulateSuccess: "Nächste Eintragsgenerierung erfolgreich simuliert",
        simulateNoDate: "Keine weiteren Daten zur Generierung (Enddatum erreicht)",
    },
    onboarding: {
        title: "Profil einrichten",
        welcome: "Willkommen!",
        subtitle: "Passen Sie Ihre Fahrerfahrung an.",
        currency: "Währung",
        preferredCurrency: "Bevorzugte Währung",
        distUnit: "Entfernungseinheit",
        volUnit: "Volumeneinheit",
        complete: "Einrichtung abschließen",
    },
    cars: {
        unitChangeWarningTitle: "Warnung bei Einheitänderung",
        unitChangeWarningMessage: "Die Änderung dieser Einheiten konvertiert Ihre vorhandenen Daten nicht. Alle historischen Aufzeichnungen bleiben genau wie eingegeben.",
        unitChangeWarningConfirm: "Verstanden",
        title: "Garage",
        carAdmins: "Fahrzeugadministratoren",
        sharedWithMe: "Mit mir geteilt",
        manageAdmins: "Administratoren verwalten",
        adminEmail: "Administrator E-Mail",
        addAdmin: "Administrator hinzufügen",
        addAdminPlaceholder: "z.B. freund@email.com",
        removeAdmin: "Entfernen",
        removeAdminConfirm: "Sind Sie sicher, dass Sie diesen Administrator entfernen möchten?",
        adminAdded: "Administrator hinzugefügt",
        adminRemoved: "Administrator entfernt",
        removeMyAccess: "Zugriff entfernen",
        removeMyAccessConfirm: "Sind Sie sicher, dass Sie auf dieses Fahrzeug verzichten möchten?",
        myAccessRemoved: "Zugriff entfernt",
        noAdminsYet: "Noch keine Administratoren hinzugefügt.",
        adminInfoText: "Administratoren können Ausgaben, Notizen und Ersatzteile hinzufügen und bearbeiten, aber das Fahrzeug selbst nicht löschen.",
        newCar: "Auto hinzufügen",
        carNotFound: "Auto nicht gefunden",
        carNotFoundDesc: "Das angeforderte Auto existiert nicht oder Sie haben keinen Zugriff.",
        accessDenied: "Zugriff verweigert",
        accessDeniedDesc: "Dieses Auto ist privat und nicht öffentlich verfügbar.",
        backToHome: "Zurück zur Startseite",
        adminRestricted: "Zugriff eingeschränkt",
        adminRestrictedDesc: "Nur autorisierte Administratoren können auf diese Konsole zugreifen. Bitte kehren Sie zur Hauptanwendung zurück.",
        returnHome: "Zurück zur Startseite",
        editCar: "Auto bearbeiten",
        name: "Fahrzeugname",
        model: "Modell",
        year: "Jahr",
        plate: "Kennzeichen",
        vin: "Fahrgestellnummer",
        mileage: "Aktueller Kilometerstand",
        initialMileage: "Anfangskilometerstand",
        engineType: "Motortyp",
        tapToChangeIcon: "Tippen um Symbol zu ändern",
        chooseIcon: "Icon wählen",
        imageTab: "Bild",
        iconTab: "Symbol",
        chooseColor: "Farbe wählen",
        chooseEmoji: "Emoji wählen",
        uploadImage: "Bild hochladen",
        clickToBrowse: "Klicken Sie, um Dateien zu durchsuchen",
        currentCarIcon: "Aktuelles Auto-Icon",
        changeImage: "Bild ändern",
        zoom: "Vergrößern",
        rotate: "Drehen",
        removeChangeImage: "Bild entfernen / ändern",
        selectIcon: "Icon auswählen",
        cropAndSave: "Zuschneiden & Speichern",
        displayName: "Anzeigename",
        displayNamePlaceholder: "z.B. Mein Wochenendauto",
        makeLabel: "Marke *",
        modelLabel: "Modell *",
        yearLabel: "Jahr *",
        fuelTypeLabel: "Typ *",
        licensePlateLabel: "Kennzeichen",
        vinLabel: "Fahrgestellnummer",
        notesLabel: "Notizen (optional)",
        notesPlaceholder: "z.B. 1.6 TDI, 85kW, 1588cc, Batterie 62kWh, AWD, usw.",
        publicAccess: "Auto öffentlich zugänglich machen",
        publicAccessDesc: "Andere können dieses Auto über einen geteilten Link einsehen",
        shareLocations: "Erlauben Sie die Anzeige auch hinzugefügter Standorte",
        shareLocationsDesc: "Aktivieren Sie dies, um die Fahrzeugstandorte in der öffentlichen Ansicht sichtbar zu machen",
        deleteCar: "Auto löschen",
        deleteCarTitle: "Auto löschen",
        deleteCarConfirm: "Möchten Sie '{name}' wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
        noCars: "Keine Autos in Ihrer Garage",
        addFirstCarNote: "Beginnen Sie Ihre Reise, indem Sie Ihr erstes Fahrzeug hinzufügen, um Ausgaben zu verfolgen.",
        addVehicle: "Fahrzeug hinzufügen",
        myVehicles: "Meine Fahrzeuge",
        favorites: "Favoriten",
        deleteConfirm: "Möchten Sie dieses Auto wirklich löschen? Alle zugehörigen Ausgaben werden ebenfalls gelöscht.",
        deleteFailed: "Auto konnte nicht gelöscht werden",
        saveFailed: "Fahrzeugdaten konnten nicht gespeichert werden",
        adminActions: "Admin-Aktionen",
        importCsv: "CSV importieren",
        clearData: "Daten löschen",
        distanceUnitLabel: "Entfernungseinheit",
        volumeUnitLabel: "Volumeneinheit",
        currencyLabel: "Währung",
        boughtAt: "Kaufdatum",
        purchasePrice: "Kaufpreis",
        purchaseMileage: "Kilometerstand beim Kauf",
        createPurchaseRecord: "Kaufhistorie automatisch erstellen",
        makePlaceholder: "z.B. BMW",
        modelPlaceholder: "z.B. X5",
        platePlaceholder: "z.B. AB-1234",
        vinPlaceholder: "Fahrgestellnummer...",
        purchaseInfoNote: "Diese Information erstellt einen initialen 'Information'-Eintrag in Ihrem Verlauf mit den angegebenen Daten.",
        availableTypes: "Verfügbare Typen",
        dragToReorder: "Zum Neuanordnen ziehen",
        requestTypeNote: "Wenn Sie einen anderen Typ benötigen - ",
        requestTypeAction: "lassen Sie es uns wissen!",
        emailProcessingTitle: "E-Mail-Verarbeitung",
        emailInstructions: "Leiten Sie Ihre Quittungen an die untenstehende Adresse weiter. Wir extrahieren die Daten und erstellen Ausgaben automatisch.",
        recentEmails: "Erhaltene E-Mails",
        viewAllEmails: "ALLE ANZEIGEN ({count})",
        noEmailsReceived: "Noch keine E-Mails empfangen.",
        analysisResult: "Analyseergebnis",
        vehicleInfo: "Fahrzeuginformationen",
        preferences: "Einstellungen",
        purchaseHistory: "Kaufverlauf",
        emailProcessing: "E-Mail-Verarbeitung",
        publicAccessTitle: "Öffentlicher Zugang",
        expenseTypesTitle: "Ausgabetypen",
        adminActionsTitle: "Admin-Aktionen",
        enterPurchaseDateAlert: "Bitte geben Sie das Kaufdatum ein",
        allowedSenderEmails: "Erlaubte Absender-E-Mails",
        allowedEmailsDesc: "Fügen Sie E-Mail-Adressen hinzu, die berechtigt sind, Belege an dieses Fahrzeug zu senden. Maximal 5 Adressen.",
        noAllowedEmails: "Keine erlaubten E-Mails hinzugefügt.",
        emailAlreadyAdded: "Diese E-Mail ist bereits für dieses Fahrzeug erlaubt.",
        maxAllowedEmailsReached: "Maximales Limit der erlaubten E-Mails erreicht.",
        addAllowedEmailPlaceholder: "Erlaubte E-Mail hinzufügen...",
        ownerEmail: "Besitzer",
        onlyOwner: "nur Eigentümer",
        defaultAllowed: "Immer erlaubt",
        carLimitReachedTitle: "Auto-Limit erreicht",
        carLimitReachedMessage: "Ihr {plan}-Plan erlaubt {limit} Auto(s). Sie haben bereits {current}. Gehen Sie zu den Einstellungen, um Ihre Limits zu sehen oder kontaktieren Sie uns, um ein Upgrade durchzuführen.",
        carLimitGoToSettings: "Zu den Einstellungen gehen",
        archivedCars: "Archiviert",
        archiveCar: "Auto archivieren",
        unarchiveCar: "Auto wiederherstellen",
        sellDate: "Verkaufsdatum",
        sellPrice: "Verkaufspreis",
        sellMileage: "Verkaufsmileage",
        archiveConfirm: "Sind Sie sicher, dass Sie dieses Auto archivieren möchten?",
        archiveInstructions: "Das Archivieren eines Autos bedeutet, dass es nicht mehr Ihnen gehört oder Sie es nicht mehr warten. Bitte geben Sie die Verkaufsdetails für die Statistiken an. Dadurch wird das Auto schreibgeschützt.",
        archivedBadge: "Archiviert",
        saleDetails: "Verkaufsdetails",
        saleDetailsNote: "Verkaufsdetails werden für Statistiken verwendet. Sie können sie bei Bedarf aktualisieren.",
        archiveDetailsNotFillable: "Bitte füllen Sie alle Felder aus, um das Auto zu archivieren",
        emailAddressWillBeAvailableAfterSave: "Die E-Mail-Adresse wird nach dem Speichern des Fahrzeugs verfügbar sein.",
        proFeatureAdminTitle: "Pro-Funktion: Fahrzeugadministratoren",
        proFeatureAdminDesc: "Fügen Sie andere Benutzer hinzu, die diese Fahrzeugdaten anzeigen und verwalten können.",
        proFeatureEmailTitle: "Pro-Funktion: Zusätzliche Absender",
        proFeatureEmailDesc: "Fügen Sie weitere erlaubte E-Mail-Adressen hinzu, von denen Quittungen an dieses Fahrzeug gesendet werden können.",
        estimatedMileage: "Geschätzte Kilometerleistung",
        summaryFrequencyLabel: "Zusammenfassungsfrequenz",
        summaryFrequencyOptions: {
            none: "Aus",
            monthly: "Monatlich",
            semiAnnually: "Halbjährlich",
            annually: "Jährlich",
        },
        healthProfilePrompt: "Vervollständigen Sie Ihr Gesundheitsprofil für eine genaue Analyse!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Benzin",
        diesel: "Diesel",
        hybrid: "Hybrid",
        electric: "Elektro",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Laufleistungstrend",
        title: "Statistiken",
        allYears: "Alle Jahre",
        totalSpent: "Gesamtausgaben",
        spentIn: "Ausgaben in {year}",
        perMonth: "pro Monat",
        overall: "gesamt",
        vsPrev12m: "vs Vorjahr (12m)",
        rolling12m: "Letzte 12m",
        byType: "Nach Typ",
        byMonth: "Nach Monat",
        byYear: "Nach Jahr",
        noData: "Keine Daten für dieses Jahr",
        mostExpensive: "Am teuersten",
        top: "Oben",
        untitled: "Ohne Titel",
        assetAnalysis: "Vermögenswert & Kostenanalyse",
        burnNote: "* 'Gesamtverbrauch' umfasst sowohl ausgegebenes Geld als auch den geschätzten Wertverlust des Fahrzeugs.",
        carMarketValue: "Fahrzeugmarktwert",
        cumulativeCosts: "Kumulative Kosten",
        totalBurn: "Gesamtverbrauch (Kosten + Abschr.)",
        entries: "Einträge",
        avgPrice: "Durchschnittspreis",
        consumption: "Verbrauch",
        price: "Preis",
        fuelPriceTrend: "Kraftstoffpreistrend",
        spendingTrend: "Ausgabentrend",
        costPerKmTrend: "Kosten pro 1 km",
        costPerMileTrend: "Kosten pro 1 Meile",
        serviceTrendsTitle: "Service-Trends",
        expensesOnMap: "Ausgaben auf der Karte",
        visitsCountLabel: "Besuche",
        locationsSummary: "Standorte Zusammenfassung",
        locationsCountLabel: "Orte",
        noLocationsFoundTitle: "Noch keine Standorte",
        noLocationsFoundDesc: "Fügen Sie Standorte zu Ihren Aufzeichnungen hinzu, um sie auf der Karte zu sehen.",
        addMileageData: "Kilometerstand hinzufügen",
        missingMileageInfo: "Nicht genügend Daten, um die Kosten pro Entfernung zu berechnen. Fügen Sie mindestens 2 Kilometerstandsmessungen in diesem Zeitraum hinzu (oder eine vor diesem Zeitraum).",
        mileageModal: {
            title: "Fehlenden Kilometerstand hinzufügen",
            description: "Um die Kosten pro Entfernung für {year} genau zu berechnen, müssen wir den Kilometerstand zu Beginn und am Ende des Jahres kennen.",
            startOfYear: "Jahresbeginn (1. Jan)",
            endOfYear: "Jahresende (31. Dez)",
            currentMileage: "Aktueller Kilometerstand",
            placeholder: "Kilometerstand eingeben...",
            save: "Daten speichern",
            foundNearby: "In der Nähe gefunden ({date}): {value} {unit}",
            useExisting: "Verwenden Sie dies",
        },
        proAnalysis: "Pro-Analyse",
        detailedAnalysis: "Detaillierte Analyse",
        upgradeToSee: "Upgrade, um zu sehen →",
    },
    tabs: {
        dashboard: "Übersicht",
        expenses: "Ausgaben",
        stats: "Statistiken",
        locations: "Standorte",
        gallery: "Galerie",
        parts: "Teile",
        notes: "Notizen",
        repair: "Reparaturmodus",
        'repair-switch': "Autowechsel",
    },
    repairAnalysis: {
        title: "Reparaturentscheidungsanalyse",
        ownershipLength: "Besitzdauer",
        currentValue: "Aktueller Wert",
        valueOutdated: "Wert könnte veraltet sein",
        addValueToEnable: "Aktuellen Fahrzeugwert hinzufügen, um die Analyse zu aktivieren",
        totalInvested: "Insgesamt investiert",
        totalInvestedSub: "Kaufpreis + Reparaturen",
        totalExcludesFuel: "schließt Kraftstoff / Strom aus",
        fuelLabelFuelOnly: "Kraftstoffgesamt",
        fuelLabelEnergyOnly: "Energietotal",
        fuelLabelHybrid: "Kraftstoff & Energietotal",
        fuelTypeFuel: "Kraftstoff",
        fuelTypeEnergy: "Strom",
        fuelTypeHybrid: "Kraftstoff & Strom",
        fuelTotalLabel: "Kraftstoff/Energie insgesamt:",
        projectionMode: "Prognosemodus",
        projectionModes: {
            lastYear: "Basierend auf dem letzten Jahr",
            average: "Historischer Durchschnitt",
            trend: "Trend (linear)",
        },
        brakeAssumption: "Wartung beinhaltet geschätzten 3-Jahres-Bremszyklus",
        repairBuffer: "Beinhaltet altersbedingten Reparaturrisikopuffer",
        yearLabel: "Jahr",
        totalInvestedDesc: "Kaufpreis + alle Reparaturen",
        repairToValue: "Reparatur zum Wert (12 Monate)",
        repairToValueExplain: "Reparaturen €{cost} vs Fahrzeugwert €{value}. Unter 20% ist gesund; über 50% ist hohes Risiko.",
        ownershipPressure: "Besitzdruck",
        ownershipPressureExplain: "Gesamtkostenbelastung: Reparaturen €{cost} + Wertverlust vs €{value}. Über 35% signalisiert finanziellen Stress.",
        investmentGap: "Investitionslücke",
        investmentGapExplain: "Insgesamt investiert €{invested} minus aktueller Wert €{value}. Dies zeigt, wie viel Sie bisher 'verloren' haben.",
        investmentGapDesc: "Insgesamt investiert - aktueller Wert",
        repairExpenses12m: "Reparaturkosten 12 Monate",
        calculatedYearlyMileage: "Berechnete jährliche Kilometerleistung: {km} km",
        calculatedYearlyRepairs: "Berechnete jährliche Reparaturen: {amount}",
        set: "Festlegen",
        plannedRepairCost: "Geplante Reparaturkosten",
        whatIfTitle: "Was, wenn Sie jetzt {amount} ausgeben?",
        updatedScore: "Aktualisierte Punktzahl",
        updatedVerdict: "Aktualisiertes Urteil",
        howIsItCalculated: "Wie wird das berechnet?",
        usedLifespan: "Genutzt: {usage}% der erwarteten Lebensdauer",
        remainingLifespan: "Verbleibend: ~{km} km",
        estimatedLifespan: "Geschätzte Lebensdauer: {km} km",
        lifecycle_stage_early: "Frühe Lebensphase – geringes Risiko für größere Ausfälle",
        lifecycle_stage_mid: "Mittlere Lebensphase – normaler Verschleiß",
        lifecycle_stage_late: "Späte Lebensphase – erhöhtes Risiko für Reparaturen",
        lifecycle_stage_end: "Ende der erwarteten Lebensdauer – hohes Risiko für größere Reparaturen",
        calculationExplanation: "Die Analyse verwendet den Kaufpreis Ihres Fahrzeugs, die aktuellen Reparaturkosten und den geschätzten aktuellen Wert, um einen finanziellen Gesundheitswert zu berechnen. Hohe Reparaturkosten im Verhältnis zum Fahrzeugwert oder schnelle Wertminderung senken den Wert.",
        confidenceLabel: "Vertrauen",
        confidenceLevel: {
            high: "Hoch",
            medium: "Mittel",
            low: "Niedrig",
        },
        mentalFactorsTitle: "Verbessern Sie die Genauigkeit mit Ihrer Erfahrung",
        mentalFactorsCTA: "Schnellcheck (30 Sek.)",
        mentalFactorsSurveyTitle: "Ihre Erfahrung",
        mentalFactorsSurveyDesc: "Beantworten Sie 3 kurze Fragen, um Ihre Punktzahl zu personalisieren.",
        q1: "Erfüllt Ihr Auto Ihre Bedürfnisse?",
        q1Help: "Platz, Komfort, Funktionen",
        q2: "Fahren Sie gerne mit Ihrem Auto?",
        q2Help: "Optik, Komfort, Gefühl",
        q3: "Machen Sie sich Sorgen über unerwartete Pannen?",
        q3Help: "Zuverlässigkeitsbedenken",
        q4: "Ist dieses Auto für die Familie und lange Reisen gedacht?",
        q4Help: "Sicherheit und Zuverlässigkeit haben Priorität",
        factorsTitle: "Punktzahlfaktoren",
        factorsDesc: "Sehen Sie, was Ihre Punktzahl beeinflusst",
        newCarComparison: "Neuwagenvergleich",
        newCarComparisonDesc: "Vergleichen Sie Ihre aktuellen monatlichen Kosten mit dem Kauf eines neuen Autos.",
        modeLeasing: "Leasing",
        modeFullPrice: "Vollpreis",
        downPayment: "Anzahlung",
        leaseYears: "Laufzeit (Jahre)",
        monthlyPayment: "Monatliche Zahlung",
        carPrice: "Gesamtpreis des Fahrzeugs",
        ownershipYears: "Geplante Besitzdauer (Jahre)",
        insuranceMonthly: "Monatliche CASCO / Versicherung",
        currentMonthlyCost: "Aktuelle Autokosten",
        newCarMonthlyCost: "Kosten für das neue Auto",
        newCarCheaper: "Neues Auto ist günstiger um: {amount} / Monat",
        newCarMoreExpensive: "Neues Auto ist teurer um: {amount} / Monat",
        newCarSameCost: "Die Kosten sind genau gleich.",
        advancedSettings: "Erweiterte Einstellungen",
        yearlyMaint: "Jährliche Wartung (€)",
        tyres3Yrs: "Reifen / 3 Jahre (€)",
        depreciation5Yrs: "Abschreibung (5 Jahre %)",
        newCarYear: "Neues Auto Jahr",
        cumulativeCosts: "Kumulative Kosten (Projektion)",
        comparisonByYear: "Vergleich nach Jahr",
        currentCarLabel: "Aktuelles Auto",
        newCarLabel: "Neues Auto",
        resaleValue: "Wiederverkaufswert",
        startupCosts: "Anlaufkosten (Gebrauchtwagen)",
        inspection: "Vor-Kaufinspektion",
        initialMaintenance: "Erstwartung + Öle",
        registration: "Zulassung / Gebühren",
        total: "Gesamt",
        currentCarTitle: "Aktuelles Auto",
        newCarTitle: "Potentielles Auto",
        upfrontInvestment: "Anfängliche Investition",
        monthlyReality: "Echte monatliche Kosten",
        depreciationShort: "Abschreibung",
        howCalculated: "Wie wird das berechnet?",
        deltaMonthly: "Monatliche Differenz",
        deltaUpfront: "Anfängliche Differenz",
        surveyMeanings: {
            practical: {
                1: "Überhaupt nicht",
                2: "Schlechte Passform",
                3: "Durchschnittlich",
                4: "Gute Passform",
                5: "Perfekte Passform",
            },
            joy: {
                1: "Frustrierend",
                2: "Langweilig",
                3: "Durchschnittlich",
                4: "Angenehm",
                5: "Sehr viel",
            },
            worry: {
                1: "Nicht besorgt",
                2: "Leicht besorgt",
                3: "Besorgt",
                4: "Sehr besorgt",
                5: "Sicher, dass ich jeden Moment liegen bleibe",
            },
        },
        verdicts: {
            KEEP: "Finanziell sinnvoll zu behalten",
            borderline: "Grenzwertig – genau beobachten",
            sell: "Hohes finanzielles Risiko – Verkauf könnte rational sein",
        },
        factors: {
            trendInc: "Steigender Trend",
            trendIncDesc: "Reparaturkosten steigen im Vergleich zum letzten Jahr.",
            lowDepreciation: "Vorteil der niedrigen Abschreibung",
            lowDepreciationDesc: "Ältere/günstigere Autos verlieren im Laufe der Zeit weniger an Wert.",
            stableRepairs: "Stabile Reparaturen",
            stableRepairsDesc: "Ihre Reparaturkosten sind stabil oder sinkend.",
            noHistoricalData: "Keine Daten älter als 6 Monate.",
            lifecycle_stage: "Lebenszyklusphase des Fahrzeugs",
            high_risk_phase: "Hochrisikophase",
            high_risk_phase_desc: "Die Kombination aus einer späten Lebenszyklusphase und steigenden Reparaturkosten deutet auf ein hohes Risiko hin.",
            lowCostKm: "Effiziente Kosten pro KM",
            lowCostKmDesc: "Die Gesamteffizienz des Betriebs dieses Autos ist ausgezeichnet.",
            lowFixedCosts: "Niedrige Fixkosten",
            lowFixedCostsDesc: "Ihre Fixkosten (Steuern, Versicherung) sind niedrig.",
            usage: "Jährliche Nutzung",
            usageDesc: "Gefahrene Strecke in den letzten 12 Monaten.",
            accidentMinor: "Kleiner Unfall",
            accidentMinorDesc: "Kosmetische Schäden oder kleine Reparaturen.",
            structuralDamage: "Strukturelle Schäden",
            structuralDamageDesc: "Rahmen- oder Strukturprobleme senken den Wert drastisch.",
            aiLifespanNearEnd: "Ende der erwarteten Lebensdauer",
            aiLifespanAging: "Alternde Komponenten",
            aiLifespanGood: "Vorteil der niedrigen Kilometerleistung",
            aiLifespanDesc: "Basierend auf der von der KI geschätzten typischen Lebensdauer für dieses Modell.",
            aiUpcomingRepairs: "Bevorstehende Reparaturen (KI-Vorhersage)",
            aiUpcomingRepairsDesc: "Die KI sagt voraus, dass bald größere Komponentenfehler basierend auf der Kilometerleistung auftreten.",
            ownershipFatigue: "Besitzermüdung",
            ownershipFatigueLong: "Langfristiger Besitz führt oft zu mentaler Bereitschaft für ein anderes Fahrzeug.",
            ownershipFatigueShort: "Anfängliche Besitzverzerrung schafft eine stärkere Tendenz, das Auto zu behalten.",
            family_priority: "Familie & Lange Reisen",
            replacement_comparison: "Ersatzvergleich",
            none: "Keine",
            surface: "Oberfläche",
            minor: "Geringfügig",
            moderate: "Mäßig",
            severe: "Schwerwiegend",
            structural: "Strukturell",
            major: "Wesentlich",
            critical: "Kritisch",
            full: "Vollständig",
            improveLabel: "Was würde das verbessern:",
            info_original_price: "Der ungefähre Preis dieses Autos, als es neu war. Hilft, die Wertstabilität zu schätzen. Ältere Autos mit niedrigem Restwert sind finanziell sicherer.",
            info_current_value: "Wie viel Sie es heute verkaufen könnten. Wird verwendet, um zu überprüfen, ob Reparaturen einen großen Prozentsatz des Fahrzeugwerts ausmachen, was auf eine schlechte Investition hinweist.",
            info_yearly_mileage: "Höhere Kilometerleistung erhöht den Verschleiß. Niedrige Kilometerleistung kann die Lebensdauer des Autos erheblich verlängern.",
            info_estimated_repairs: "Laufende Kosten, um das Auto am Laufen zu halten. Hohe jährliche Kosten verringern die Attraktivität, das Auto zu behalten.",
            info_planned_repairs: "Bekannte bevorstehende Reparaturen. Simuliert den sofortigen Druck auf Ihre Entscheidung.",
            info_ownership_years: "Wie lange besitzen Sie dieses Auto? Dies beeinflusst die psychologische Ermüdung des Eigentums und die Voreingenommenheit des Erstkäufers.",
            info_rust: "Kritisches langfristiges Risiko. Struktureller Rost verringert die Sicherheit. Schwerer Rost macht den Verkauf zu einer besseren Option.",
            info_crashes: "Strukturelle Unfälle beeinflussen Sicherheit und Zuverlässigkeit. Sie verringern auch den Wiederverkaufswert erheblich.",
            info_repaint: "Zeigt frühere Schäden oder kosmetische Reparaturen an. Geringer Einfluss, es sei denn, tiefere Probleme wurden verborgen.",
            info_unresolved: "Verborgene zukünftige Kosten. Bekannte Mängel in der Elektronik, im Motor oder in der Wartung, die Aufmerksamkeit benötigen.",
            info_fit: "Passt das Auto zu Ihren Bedürfnissen (Platz, Komfort)? Eine schlechte Passform bedeutet, dass Sie es eher ersetzen werden.",
            info_joy: "Emotionaler Wert zählt. Kein Freude bedeutet, dass Sie mental bereit für ein neues Auto sind.",
            info_worry: "Wahrgenommener Zuverlässigkeitsstress. Hohe Sorgen sind ein starkes Signal, das Auto zu ersetzen.",
        },
        explanations: {
            repairFreq: "Ihr Auto hatte {visits} Werkstattbesuche in den letzten 12 Monaten. Häufige Besuche deuten auf eine geringere Zuverlässigkeit und höhere Unannehmlichkeiten hin.",
            repairVsValue: "In den letzten 12 Monaten haben Ihre Reparaturen €{cost} gekostet, während der geschätzte Wert des Autos €{value} beträgt. Das sind {ratio}% des Gesamtwerts des Autos.",
            stableRepairsDetailYearly: "Im letzten Jahr haben Sie €{cost1} für Reparaturen ausgegeben, im Jahr davor €{cost2}. Veränderung von {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "In den letzten 6 Monaten haben Sie €{cost1} ausgegeben, in den vorherigen 6 Monaten €{cost2}. Veränderung von {percent}% ({trend}).",
            mileage: "Bei {mileage} km betritt das Auto eine höhere Risikozone für größere Teileausfälle (Getriebe, Motorbauteile).",
            planned: "Sie haben €{cost} für geplante Reparaturen, was die finanzielle Sicherheit beim Behalten des Autos sofort verringert.",
            lowDep: "Autos im Wert von etwa €{value} verlieren pro Jahr sehr wenig an Wert, was höhere Reparaturkosten ausgleicht.",
            depRisk: "Ihr Auto ist {age} Jahre alt und hat seinen Abschreibungszyklus größtenteils abgeschlossen, was bedeutet, dass Sie kein Geld durch den Wertverlust verlieren.",
            stable: "Sie haben in diesem Jahr €{costThisYear} ausgegeben im Vergleich zu €{costLastYear} im letzten Jahr, was einen Rückgang von {percent}% darstellt. Vorhersehbare Kosten sind mathematisch vorteilhaft.",
            costKm: "Sie sind im letzten Jahr {km} km gefahren. Die Betriebskosten betrugen €{costKm} pro Kilometer, was eine ausgezeichnete wirtschaftliche Effizienz zeigt.",
            fixedCosts: "Sie haben €{costs} an festen jährlichen Kosten (Versicherung/Steuer) bezahlt. Dieser niedrige Fußabdruck gibt zusätzliches beruhigendes Gefühl.",
            usage: "Sie fahren basierend auf Ihren Protokollen etwa {km} km pro Jahr.",
            practical_fit: "Sie haben die praktische Eignung mit {score}/5 bewertet und die mathematische Bewertung um {impact} Punkte angepasst.",
            emotional_satisfaction: "Sie haben Ihre emotionale Zufriedenheit mit {score}/5 bewertet und die Bewertung um {impact} Punkte angepasst.",
            reliability_anxiety: "Ihr Vertrauen in die Zuverlässigkeit beträgt {score}/5 und beeinflusst die Bewertung um {impact} Punkte.",
            rust: "Schwere strukturelle oder Unterbodenrostbildung bedeutet typischerweise Sicherheitsrisiken oder Abwrack-Szenarien.",
            accident: "Frühere Schäden, abhängig von der Schwere, reduzieren in der Regel den Wiederverkaufswert und die Sicherheit des Fahrzeugs.",
            structural: "Strukturelle Probleme machen das Auto automatisch finanziell gefährlich.",
            ai_lifespan: "Bei {current} km hat das Auto {ratio}% seiner von der KI geschätzten Lebensdauer ({expect} km) abgeschlossen.",
            ai_repairs: "Die KI-Daten zeigen, dass bei dieser Kilometerleistung {count} typische modell-spezifische größere Reparaturen auftreten.",
            lifecycle_stage: "Was bedeutet Lebensdauer? {total} km – dies ist der von der KI vorhergesagte Punkt, an dem größere strukturelle Reparaturen (Motor, Getriebe usw.) typischerweise für dieses Modell beginnen. Es ist nicht das Ende des Lebens des Autos – das Auto kann weiterhin fahren, aber mit erheblich höheren Wartungskosten. Die typische physische Lebensdauer eines Autos liegt bei 500k–1M km, aber es wird viel früher wirtschaftlich untragbar.",
        },
        ratios: {
            healthy: "Gesund",
            monitor: "Überwachen",
            highRisk: "Hohes Risiko",
            stable: "Stabil",
            warning: "Warnung",
            financialStress: "Finanzieller Stress",
        },
        proFeatureTitle: "Pro-Funktion: Reparaturmodus",
        proFeatureDesc: "Schalten Sie die Entscheidungsmaschine frei, um eine professionelle finanzielle Analyse Ihrer Fahrzeugreparaturen zu erhalten. Kostenlose Nutzer sehen eine Demonstration mit Beispieldaten.",
        viewDemo: "Live-Demo ansehen",
        upgradeToUnlock: "Upgrade auf PRO, um Ihr Auto zu analysieren",
    },
    carTasks: {
        title: "Fahrzeugaufgaben",
        placeholderTitle: "Wartungsverfolgung",
        placeholderDesc: "Wartungsplan für Ihr Fahrzeugmodell.",
        demoTitle: "Fahrzeugwartungsaufgaben",
        demoSubtitle: "Intelligente Verfolgung für Ihr Fahrzeug",
        feature1Title: "Automatisierte Aufgabenerstellung",
        feature1Desc: "Generiert automatisch Aufgaben wie Ölwechsel, Filterwechsel und Zahnriemenprüfungen basierend auf dem Modell Ihres Fahrzeugs.",
        feature2Title: "Kostenintegration",
        feature2Desc: "Analysiert Ihre Servicehistorie, um zu verstehen, was bereits erledigt wurde und wann.",
        feature3Title: "Intelligente Erinnerungen",
        feature3Desc: "Erhalten Sie Benachrichtigungen basierend auf Zeit und Kilometerstand. Die Verfolgung wird automatisch zurückgesetzt, wenn Sie eine Aufgabe als erledigt markieren.",
        getStarted: "Loslegen",
        fakeDoorPopupTitle: "Feedback Willkommen",
        fakeDoorPopupMessage: "Wir entwickeln derzeit Fahrzeugwartungsaufgaben. Diese Funktion ermöglicht es Ihnen, Serviceintervalle automatisch zu verfolgen. Welche spezifischen Aufgaben oder Funktionen würden Sie am meisten sehen wollen?",
        fakeDoorPopupPlaceholder: "Ihre Gedanken...",
        noTasksYet: "Noch keine Aufgaben",
        deleteAllTitle: "Aufgabenliste leeren?",
        deleteAllMessage: "Sind Sie sicher, dass Sie alle {count} Aufgaben für dieses Auto löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        deleteAllSuccess: "Alle Aufgaben wurden erfolgreich gelöscht.",
        sortPriority: "Priorität",
        sortType: "Typ",
        sortDate: "Neueste",
        status: {
            overdue: "ÜBERFÄLLIG",
            pending: "ANSTEHEND",
            noData: "KEINE DATEN",
            upcoming: "Bevorstehend",
            nextIn: "Nächste in {dist} {unit}",
            overdueBy: "{dist} {unit} überfällig",
            afterDays: "In {days} Tagen",
            overdueDays: "{days} Tage überfällig",
        },
        form: {
            newTitle: "Neue Aufgabe",
            actionType: "Überprüfen oder Ersetzen?",
            intervalMonths: "Intervall (Monate)",
            intervalDistance: "Intervall (Entfernung)",
            diffFirstInterval: "Erstes Intervall weicht vom Basisintervall ab",
            firstInterval: "Erstes Intervall",
            historyToggle: "Wurde diese Aufgabe jemals für dieses Auto durchgeführt?",
            historyToggleDesc: "Wenn NEIN, gehen wir davon aus, dass es seit der Produktion nie gemacht wurde.",
            lastPerformedOptional: "Wann wurde es zuletzt durchgeführt? (Optional)",
            deleteTitle: "Aufgabe löschen",
            deleteConfirm: "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
            saveError: "Fehler beim Speichern der Aufgabe",
            historyConfirmed: "Historie bestätigt",
            reminders: "Erinnerungen",
            notifyMileage: "Benachrichtige mich, wenn die geschätzte Kilometerzahl erreicht ist",
            notifyDate: "Benachrichtige mich, wenn das Datum erreicht ist",
            nextMileageReminder: "Geschätztes Datum",
            nextDateReminder: "Fälligkeitsdatum",
            estimatedDate: "Geschätztes Datum",
            missingLastMileage: "Fehlende letzte gefahrene Kilometer",
            missingLastDate: "Fehlendes letztes Datum",
            missingStartDate: "Startdatum konnte nicht bestimmt werden",
            additionalOptions: "Zusätzliche Optionen",
            reminderInfoMissing: "Informationsstatus: Erinnerungen sind deaktiviert, bis die zuletzt durchgeführten Daten bereitgestellt werden.",
        },
    },
    dashboard: {
        title: "Übersicht",
        quickActions: "Schnellaktionen",
        addExpense: "Ausgabe hinzufügen",
        editCar: "Auto bearbeiten",
        recentExpenses: "Ausgaben",
        seeAll: "Alle ansehen",
        recentGallery: "Dateien",
        thisMonth: "Diesen Monat",
        totalSpent: "Gesamtausgaben",
        avgPerMonth: "Ø pro Monat",
        recentNotes: "Notizen",
        recentParts: "Teile",
        noRecentExpenses: "Keine aktuellen Ausgaben",
        noRecentGallery: "Keine aktuellen Fotos",
        noRecentNotes: "Keine aktuellen Notizen",
        noRecentParts: "Keine aktuellen Teile",
        createNote: "Neu erstellen",
        createPart: "Neu erstellen",
        createExpense: "Neue erstellen",
        noFiles: "Keine Dateien hinzugefügt",
        needSomethingMore: "Brauchen Sie etwas mehr?",
        letUsKnow: "Lassen Sie es uns wissen!",
    },
    expenseTypes: {
        editTitle: "Ausgabetyp bearbeiten",
        newTitle: "Neuer Ausgabetyp",
        categoryName: "Kategoriename",
        placeholderName: "z.B. Service",
        signatureColor: "Signaturfarbe",
        icon: "Kategorie-Symbol",
        deleteConfirm: "Möchten Sie den Typ '{name}' wirklich löschen?",
    },
    spareParts: {
        title: "Ersatzteile",
        connectedWithRecords: "Verbunden mit Aufzeichnungen",
        toBuy: "Zu kaufen",
        usedInExpenses: "In Ausgaben verwendet",
        noPartsToBuy: "Keine Teile zur Einkaufsliste hinzugefügt",
        noPartsUsed: "Noch keine Teile mit Ausgaben verknüpft",
        quantity: "Menge",
        partCode: "Teilenummer",
        price: "Preis",
        link: "Link",
        comment: "Kommentar",
        addPart: "Ersatzteil hinzufügen",
        editPart: "Ersatzteil bearbeiten",
        openPart: "Teileintrag öffnen",
        nameLabel: "Name",
        manufacturerLabel: "Hersteller",
        priceLabel: "Preis ({currency})",
        imagesLabel: "Bilder & Dateien",
        linkedHistory: "Verknüpfter Verlauf",
        partManagedNote: "Dieses Teil wird über eine Ausgabe verwaltet",
        cannotDeleteNote: "* Da dieses Teil mit einer Ausgabe verknüpft ist, kann es nicht separat gelöscht werden. Löschen oder bearbeiten Sie die Ausgabe, um dieses Teil zu verwalten.",
        partNamePlaceholder: "Teilename...",
        manufacturerPlaceholder: "Bosch, Brembo, usw.",
        additionalInfoPlaceholder: "Zusätzliche Informationen...",
        namePlaceholder: "z.B. Bremsbeläge",
        codePlaceholder: "z.B. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Teil speichern",
        deletePart: "Teil löschen",
        deleteConfirm: "Möchten Sie dieses Ersatzteil wirklich löschen?",
        sparePartsLabel: "Ersatzteile",
        partNumber: "Teil #{number}",
        imagesLimitLabel: "Dateien (bis zu 5)",
        optional: "(optional)",
        selectPart: "Teil auswählen",
        createNew: "Neues Ersatzteil erstellen",
        searchPlaceholder: "Nach Name oder Code suchen...",
        noResults: "Keine Teile gefunden",
        noPartsYet: "Noch keine Teile. Erstellen Sie Ihr erstes!",
        selectorDescription: "Suchen und wählen Sie ein vorhandenes Ersatzteil aus oder erstellen Sie ein neues",
        alreadyAdded: "Dieses Teil ist bereits hinzugefügt",
        statistics: {
            avgPrice: "Ø",
            lastPrice: "Zuletzt",
            usedTimes: "{count}x verwendet",
            totalPurchased: "Gesamt: {quantity}x",
        },
        usage: {
            title: "Dieser Kauf",
            quantity: "Menge",
            pricePerUnit: "Preis pro Einheit",
            comment: "Kommentar (optional)",
            commentPlaceholder: "z.B. Bei AutoZone gekauft",
            total: "Gesamt",
            transactionData: "Diese Transaktion",
        },
        masterData: "Hauptteilinformationen",
        masterRecord: {
            title: "Teildetails (geteilt)",
            editMaster: "Haupteintrag bearbeiten",
            warning: "Änderungen am Haupteintrag wirken sich auf alle Verwendungen aus",
        },
    },
    reminders: {
        title: "Erinnerungen",
        reminder: "Erinnerung",
        noteReminder: "Notiz-Erinnerung",
        partReminder: "Teile-Erinnerung",
        today: "Heute",
        tomorrow: "Morgen",
        yesterday: "Gestern",
        inXDays: "in {x} Tagen",
        xDaysAgo: "vor {x} Tagen",
        inXMonths: "in {x} Monaten",
        xMonthsAgo: "vor {x} Monaten",
        active: "Aktiv",
        activeDesc: "Falls nötig, können Sie diese Erinnerung deaktivieren, ohne sie zu löschen",
        disabled: "Deaktiviert",
        yearly: "Jährlich",
        markSeen: "Bestätigen",
        addReminder: "Neue Erinnerung",
        editReminder: "Erinnerung bearbeiten",
        extraReminders: "Zusätzliche Erinnerungen",
        extraRemindersDesc: "Senden Sie 3 weitere Erinnerungen an den folgenden Tagen (insgesamt 4), wenn nicht gestoppt.",
        remindDate: "Datum",
        remindTime: "Uhrzeit",
        repeatYearly: "Jährlich wiederholen",
        repeatYearlyDesc: "Diese Erinnerung tritt automatisch jedes Jahr am selben Datum/Mo/Tag/Uhrzeit auf, bis sie deaktiviert wird",
        standalone: "Eigenständige Erinnerungen",
        embedded: "Verknüpfte Erinnerungen",
        noReminders: "Keine aktiven Erinnerungen",
        deleteReminder: "Erinnerung löschen",
        nameLabel: "Name",
        descriptionLabel: "Beschreibung",
        namePlaceholder: "Erinnerungsname",
        descriptionPlaceholder: "Kurze Beschreibung oder Notiz",
        simulateReminder: "Erinnerungsmoment simulieren",
        simulateSuccess: "Simulations-E-Mail gesendet",
        timezone: "Zeitzone",
        nextReminder: "Nächste Erinnerung",
        futureTimeError: "Die Erinnerungszeit muss in der Zukunft liegen",
    },
    notes: {
        title: "Notizen",
        emptyNote: "Leere Notiz",
        noNotes: "Noch keine Notizen",
        addNote: "Notiz hinzufügen",
        editNote: "Notiz bearbeiten",
        viewNote: "Notiz anzeigen",
        openNote: "Notizeintrag öffnen",
        titleLabel: "Titel",
        contentLabel: "Inhalt",
        noteTitlePlaceholder: "Notiztitel...",
        noteContentPlaceholder: "Schreiben Sie Ihre Notiz hier...",
        saveNote: "Notiz speichern",
        deleteNote: "Notiz löschen",
        publicNote: "Notiz öffentlich machen",
        publicNoteDesc: "Andere können diese Notiz über einen geteilten Link einsehen",
        deleteConfirm: "Möchten Sie diese Notiz wirklich löschen?",
        enterTitleAlert: "Bitte geben Sie einen Titel ein",
        saveFailed: "Notiz konnte nicht gespeichert werden",
        thisNote: "Diese Notiz",
        deleteFailed: "Notiz konnte nicht gelöscht werden",
        pinToTop: "Oben anheften",
    },
    locations: {
        title: "Standorte",
        singleTitle: "Standort",
        newLocation: "Neuer Standort",
        emptyLocation: "Leerer Standort",
        noLocations: "No locations yet",
        addLocation: "Standort hinzufügen",
        editLocation: "Standort bearbeiten",
        viewLocation: "Standort anzeigen",
        openLocation: "Standort öffnen",
        createNew: "Neuen Standort erstellen",
        selectLocation: "Standort auswählen",
        searchLocations: "Standorte suchen...",
        nameLabel: "Name",
        addressLabel: "Adresse oder Koordinaten",
        descriptionLabel: "Kommentar/Beschreibung",
        namePlaceholder: "z.B. Innenstadt Service",
        mapLabel: "Standort",
        searchPlaceholder: "Adresse suchen...",
        addressPlaceholder: "Adresse eingeben und auswählen...",
        descriptionPlaceholder: "Zusätzliche Informationen...",
        fillAddress: "Adresse von der Karte ausfüllen",
        saveLocation: "Standort speichern",
        deleteLocation: "Standort löschen",
        deleteConfirm: "Sind Sie sicher, dass Sie diesen Standort löschen möchten?",
        enterNameAlert: "Bitte geben Sie einen Namen ein",
        saveFailed: "Speichern des Standorts fehlgeschlagen",
        thisLocation: "Dieser Standort",
        deleteFailed: "Löschen des Standorts fehlgeschlagen",
        myLocations: "Meine Standorte",
        usedInEntries: "In Einträgen verwendet",
        noEntries: "Standort wird nicht verwendet",
        noEntriesThisCar: "Dieser Standort wurde für dieses Auto nicht verwendet",
        removeLocation: "Standort entfernen",
        noResults: "Keine Ergebnisse gefunden",
    },
    gallery: {
        title: "Galerie",
        noImages: "Keine Bilder hinzugefügt",
        addImagesNote: "Bilder zu Fahrzeug oder Ausgaben hinzufügen",
        totalImages: "Insgesamt {count} Bilder",
        imageAlt: "Bild {number}",
        commentPlaceholder: "Dateikommentar (optional)",
        isReceipt: "Diese Datei ist ein Beleg",
        deleteImageTitle: "Datei löschen",
        deleteImageConfirm: "Sind Sie sicher, dass Sie diese Datei dauerhaft löschen möchten?",
    },
    search: {
        placeholder: "Ausgaben, Teile, Notizen suchen...",
        typeToSearch: "Tippen um die Suche zu starten",
        noResults: "Keine Ergebnisse für '{query}'",
        carImage: "Fahrzeugbild",
        expenseImage: "Ausgabenbild",
        noteImage: "Notizbild",
        galleryImage: "Galeriebild",
        untitledExpense: "Ausgabe ohne Titel",
    },
    landing: {
        nav: {
            features: "Funktionen",
            howItWorks: "Wie es funktioniert",
            pricing: "Preise",
            login: "Anmelden",
            getStarted: "Loslegen",
            garage: "Garage",
        },
        hero: {
            title: "Wissen Sie genau, was Ihr Auto",
            subtitle: "wirklich kostet",
            description: "Verfolgen Sie Ausgaben, protokollieren Sie Reparaturen und sehen Sie, wohin Ihr Geld wirklich fließt.",
            subheadline: "Das professionelle, datengestützte Dashboard für akribische Autobesitzer.",
            startTracking: "Loslegen",
            viewDemo: "Demo Auto ->",
            trustSignal: "Schließen Sie sich 1.200+ akribischen Besitzern an, die bereits über 5 Millionen Kilometer realer Autokosten erfasst haben.",
            ctaNote: "Keine Kreditkarte. Keine aufdringlichen Verkäufe. Nur Klarheit.",
            benefits: {
                repairVsSell: {
                    title: `Reparieren vs. Verkaufen`,
                    description: `Erkennen Sie die Grenze "Reparieren vs. Verkaufen" — Hören Sie auf, sich zu fragen, ob Sie Geld in ein Geldgrab stecken. Wissen Sie den genauen Moment, in dem eine Reparatur keine kluge Investition mehr ist.`
                },
                costPerKm: {
                    title: `Kosten pro KM`,
                    description: `Verfolgen Sie Ihre tatsächlichen Kosten pro Kilometer — Gehen Sie über das Dashboard hinaus. Sehen Sie das vollständige finanzielle Bild Ihrer Fahrgewohnheiten, das andere Apps auslassen.`
                },
                automation: {
                    title: `Automatisierung`,
                    description: `Automatisieren Sie Ihre Buchführung — Leiten Sie einfach Ihre Rechnungen weiter oder senden Sie einfach Ihre Notizen per E-Mail. Unsere KI organisiert die technische Historie Ihres Autos für Sie.`
                }
            },
        },
        features: {
            title: "Alles, was Sie für Ihr Fahrzeug brauchen",
            subtitle: "Kein Tabellenkalkulationstabellen mehr. My Car Costs bringt professionelle Tools in Ihre persönliche Garage.",
            expenseTracking: {
                title: "Ausgabenverfolgung",
                description: "Erfassen Sie Kraftstoff, Wartung, Versicherung und Reparaturen. Kategorisieren Sie Kosten und visualisieren Sie Ausgabentrends.",
            },
            spareParts: {
                title: "Ersatzteilmanager",
                description: "Führen Sie ein detailliertes Inventar von Ersatzteilen, Teilenummern und Kompatibilitätshinweisen.",
            },
            serviceHistory: {
                title: "Servicehistorie & Notizen",
                description: "Führen Sie ein digitales Serviceheft. Fügen Sie detaillierte Notizen zu Wartungen, Modifikationen oder Zukunftsplänen hinzu.",
            },
            documentStorage: {
                title: "Dokumentenablage",
                description: "Laden Sie Quittungen, Rechnungen und Fotos hoch. Bewahren Sie alle Dokumente sicher und zugänglich auf.",
            },
            emailForwarding: {
                title: "E-Mail-Weiterleitung",
                description: "Leiten Sie Rechnungen direkt an Ihren einzigartigen Posteingang weiter. Wir extrahieren die Daten automatisch.",
            },
            multiCar: {
                title: "Mehrfahrzeug-Garage",
                description: "Verwalten Sie ein oder mehrere Fahrzeuge. Wechseln Sie sofort zwischen Fahrzeugen.",
            },
            repeatingExpenses: {
                title: "Wiederkehrende Ausgaben",
                description: "Automatisieren Sie die Verfolgung regelmäßiger monatlicher Kosten wie Versicherung, Parken oder Leasing.",
            },
            smartReminders: {
                title: "Intelligente Erinnerungen",
                description: "Setzen Sie benutzerdefinierte Benachrichtigungen für Ersatzteile und Servicenotizen, um keine Wartungsaufgabe zu verpassen.",
            },
        },
        howItWorks: {
            title: "Einfach und leistungsstark",
            step1: {
                title: "Fahrzeug hinzufügen",
                description: "Geben Sie Ihre Fahrzeugdaten ein, um Ihre digitale Garage zu erstellen.",
            },
            step2: {
                title: "Ausgaben erfassen",
                description: "Machen Sie ein Foto einer Quittung oder leiten Sie eine E-Mail weiter. Wir erledigen den Rest.",
            },
            step3: {
                title: "Einblicke erhalten",
                description: "Sehen Sie Ihre Kosten pro Kilometer, monatliche Ausgaben und Wartungsverlauf.",
            },
        },
        useCases: {
            title: "Ideal für",
            enthusiasts: {
                title: "Fahrzeugbegeisterte",
                description: "Verfolgen Sie jede Modifikation, Teilenummer und Wartungsintervall.",
            },
            dailyDrivers: {
                title: "Alltagsfahrer",
                description: "Wissen Sie genau, was Ihr täglicher Arbeitsweg kostet.",
            },
            flippers: {
                title: "Der smarte Flipper",
                description: "Erstellen Sie ein verifizierbares Datenvolumen, das den wahren Wert Ihres Autos für Käufer beweist.",
            },
            fleets: {
                title: "Kleine Flotten",
                description: "Verwalten Sie mehrere Betriebsfahrzeuge an einem Ort.",
            },
        },
        foundersNote: {
            title: "Hinweis des Gründers",
            content: "Ich baue MyCarCosts als das ultimative Werkzeug für Menschen, die sich wirklich um ihre Autos kümmern. Fehlt eine Funktion in Ihrem Workflow? Kontaktieren Sie mich direkt. Wenn es für die Gemeinschaft sinnvoll ist, werden wir es gemeinsam entwickeln.",
        },
        pricing: {
            freeLimitedTime: "Für begrenzte Zeit kostenlos",
            title: "Einfache, transparente Preise",
            subtitle: "Kostenlos starten, nach Bedarf upgraden.",
            perMonth: "Monat",
            monthly: "Monatlich",
            yearly: "Jährlich",
            save25: "25% sparen",
            billedAnnually: "Jährlich abgerechnet ({amount})",
            free: {
                title: "Kostenlos",
                cta: "Loslegen",
            },
            pro: {
                title: "Pro",
                cta: "Auf Pro upgraden",
                recommended: "Empfohlen",
                earlyAdopter: "Early-Adopter-Preis",
                priceLock: "Sichern Sie sich diesen Preis jetzt. Er könnte in Zukunft steigen.",
            },
            custom: {
                title: "Custom",
                cta: "Kontaktieren Sie uns",
            },
            features: {
                oneCar: "1 Auto",
                unlimitedExpenses: "Unbegrenzte Ausgaben",
                unlimitedSpareParts: "Unbegrenzte Ersatzteile",
                unlimitedNotes: "Unbegrenzte Notizen",
                repeatedExpenses: "Wiederholte Ausgaben",
                emailReminders: "E-Mail-Erinnerungen für Notizen und Ersatzteile",
                basicStatistics: "Grundlegende Statistiken",
                fullStatistics: "Vollständige Statistiken",
                storage50mb: "50 Mb Dateispeicher",
                unlimitedArchivedCars: "Unbegrenzte archivierte Fahrzeuge",
                dataExport: "Datenexport",
                allInFreePlus: "alles in kostenlos plus:",
                threeCars: "Bis zu 3 Autos",
                storage2gb: "2 Gb Dateispeicher",
                emailParsing: "E-Mail-Parsing",
                carAdmins: "Fahrzeugadministratoren",
                moreCars: "Mehr Fahrzeuge",
                moreFileStorage: "Mehr Dateispeicher",
                customRequirements: "Individuelle Anforderungen",
            },
            upgradePopup: {
                title: "Bald verfügbar!",
                message: "Die Pro- und benutzerdefinierten Versionen sind noch nicht gestartet, werden aber bald verfügbar sein. Um uns zu helfen, schneller zu starten - bitte notieren Sie, welche spezifischen Funktionen Sie von der Pro- / benutzerdefinierten Version erwarten oder was wir sonst verbessern können, um diese Plattform noch besser für Sie zu machen!",
                placeholder: "Schreiben Sie Ihr Feedback hier...",
                submit: "Senden",
                cancel: "Abbrechen",
                thanksTitle: "Danke!",
                thanksMessage: "Wir haben Ihr Feedback erhalten und werden daran arbeiten, MyCarCosts noch besser zu machen!",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "Wechsel von Excel oder einer anderen App?",
            subtitle: "Wir bieten einen professionellen Datenmigrationsservice an, damit Sie sofort loslegen können.",
            pricingModel: "Preismodell",
            small: {
                title: "Kleiner Datensatz",
                description: "< 500 Zeilen",
                price: "19–29 $",
            },
            medium: {
                title: "Mittlerer Datensatz",
                description: "500–5.000 Zeilen",
                price: "49 $",
            },
            large: {
                title: "Groß / Komplex",
                description: "Altsysteme oder komplexe Dateien",
                price: "Individuelles Angebot",
            },
            process: {
                title: "Wie es funktioniert",
                step1: "Sie reichen Ihre Datei ein",
                step2: "Wir bewerten die Daten",
                step3: "Einmalige Zahlung",
                step4: "Wir übernehmen den Import",
            },
            cta: "Migration anfragen",
        },
        repairAnalysisSection: {
            title: "Reparieren oder Verkaufen? Lassen Sie die Daten entscheiden.",
            subtitle: "Professionelle Finanzanalyse für Ihr Fahrzeug. Hören Sie auf zu raten und erfahren Sie, ob sich diese Reparaturen wirklich lohnen.",
            features: {
                personalized: {
                    title: "Personalisierte Analyse",
                    description: "Für Ihre verfolgten Autos verwenden wir echte historische Ausgaben und Parameter und fügen geplante Kosten hinzu, um eine Bewertung zu erstellen.",
                },
                public: {
                    title: "Öffentlicher Simulator",
                    description: "Evaluieren Sie einen potenziellen Kauf? Nutzen Sie unser öffentliches Tool unter /repair, um eine detaillierte Analyse zu erstellen, indem Sie nur einige wichtige Details eingeben.",
                },
                whatIf: {
                    title: "Was-wäre-wenn-Simulator",
                    description: "Geben Sie die geplanten Reparaturkosten ein und sehen Sie sofort, wie sich dies auf die finanzielle Bewertung Ihres Autos auswirkt.",
                },
            },
            cta: "Beispielanalyse ansehen",
        },
        faq: {
            title: "Häufig gestellte Fragen",
            subtitle: "Alles, was Sie über My Car Costs wissen müssen",
            questions: {
                mobileApps: {
                    question: "Wird es Apps für iOS und Android geben?",
                    answer: "Ja! Mobile Apps für iOS und Android kommen bald. Wir arbeiten hart daran, Ihnen das beste mobile Erlebnis zu bieten.",
                },
                dataPrivacy: {
                    question: "Sind meine Daten privat und sicher?",
                    answer: "Absolut. Ihre Daten sind verschlüsselt und sicher gespeichert.",
                },
                freePlan: {
                    question: "Ist der kostenlose Plan wirklich für immer kostenlos?",
                    answer: "Ja! Der kostenlose Plan erlaubt ein Auto. Upgrade auf Pro für bis zu 3 Autos und weitere Funktionen.",
                },
                dataExport: {
                    question: "Kann ich meine Daten exportieren?",
                    answer: "Ja, Sie können alle Ihre Daten jederzeit im CSV- oder PDF-Format exportieren.",
                },
                emailImport: {
                    question: "Wie funktioniert der E-Mail-Import?",
                    answer: "Jedes Auto erhält eine einzigartige E-Mail-Adresse. Leiten Sie einfach Ihre Rechnungen weiter und wir extrahieren die Daten.",
                },
                multipleUsers: {
                    question: "Können mehrere Personen auf dasselbe Auto zugreifen?",
                    answer: "Derzeit gehört jedes Auto zu einem Konto. Sie können jedoch ein Auto öffentlich sichtbar machen.",
                },
            },
        },
        cta: {
            title: "Bereit, die Kontrolle zu übernehmen?",
            subtitle: "Schließen Sie sich Tausenden von Fahrzeugbesitzern an, die My Car Costs vertrauen.",
            button: "Jetzt loslegen",
            note: "Keine Kreditkarte. Keine aufdringlichen Verkäufe. Nur Klarheit.",
        },
        footer: {
            product: "Produkt",
            legal: "Rechtliches",
            changelog: "Änderungsprotokoll",
            privacy: "Datenschutz",
            contact: "Kontakt",
            contactEmail: "info@mycarcosts.com",
            questions: "Haben Sie Fragen? Kontaktieren Sie uns unter:",
        },
        privacy: {
            title: "Datenschutzerklärung",
            lastUpdated: "Zuletzt aktualisiert: 24. März 2026",
            introduction: "Bei My Car Costs nehmen wir Ihren Datenschutz ernst. Diese Richtlinie erklärt, wie wir mit Ihren Daten gemäß den modernen Datenschutzstandards, einschließlich der DSGVO, umgehen.",
            dataCollection: {
                title: "Datenerfassung",
                description: "Wir erfassen nur das absolute Minimum an Informationen, die für die Bereitstellung unseres Dienstes erforderlich sind.",
                email: "Konto-Identität: Wir verwenden Ihre E-Mail-Adresse als Ihre eindeutige Kennung und für die Authentifizierung (z. B. Magic Links oder Google-Login).",
                documents: "Dokumentenspeicherung: Dateien, die Sie hochladen, werden sicher in verschlüsseltem Cloud-Speicher gespeichert.",
            },
            carData: {
                title: "Ihre Datenkontrolle",
                description: "Informationen, die Sie eingeben (Ausgaben, Kilometerstand, Teile), werden für Ihren persönlichen Gebrauch und für Analysen gespeichert.",
                noValidation: "Wir validieren die von Ihnen bereitgestellten Fahrzeugdaten nicht; es liegt in Ihrer Verantwortung, die Richtigkeit sicherzustellen.",
                privateByDefault: "Standardmäßig sind Ihre Daten privat. Technische Bezeichner für Dateien sind nicht fortlaufend und werden nicht von Suchmaschinen indiziert.",
                rightToForgotten: "Recht auf Vergessenwerden: Sie können Ihr Konto jederzeit löschen, wodurch alle Ihre Aufzeichnungen und Dateien sofort und dauerhaft entfernt werden.",
            },
            thirdParty: {
                title: "Drittanbieter-Dienste",
                description: "Wir verkaufen Ihre persönlichen Daten nicht. Bei der Verwendung von Google-Login greifen wir nur zu Identifikationszwecken auf Ihre E-Mail-Adresse zu.",
            },
            emailIngestion: {
                title: "E-Mail-Verarbeitung",
                description: "E-Mails, die an unseren Verarbeitungsdienst gesendet werden, werden gespeichert, um eine Verarbeitungshistorie bereitzustellen. Sie können jederzeit einzelne E-Mails oder Ihre gesamte Historie manuell löschen.",
            },
        },
        emails: {
            deleteAll: "Alle löschen",
            deleteAllConfirm: "Sind Sie sicher, dass Sie den gesamten E-Mail-Verlauf für dieses Auto löschen möchten? Diese Aktion ist irreversibel.",
            deleteConfirm: "Sind Sie sicher, dass Sie diese E-Mail löschen möchten?",
            noEmails: "Noch keine E-Mails erhalten.",
        },
        terms: {
            title: "Allgemeine Geschäftsbedingungen",
            lastUpdated: "Zuletzt aktualisiert: 25. März 2026",
            introduction: "Durch den Zugriff auf oder die Nutzung von MyCarCosts erklären Sie sich mit diesen Allgemeinen Geschäftsbedingungen einverstanden. Wenn Sie nicht einverstanden sind, nutzen Sie unseren Dienst bitte nicht.",
            acceptance: {
                title: "1. Annahme der Bedingungen",
                description: "Diese Bedingungen stellen eine rechtlich bindende Vereinbarung zwischen Ihnen und MyCarCosts bezüglich Ihrer Nutzung unserer Anwendung und Dienste dar.",
            },
            service: {
                title: "2. Beschreibung des Dienstes",
                description: "MyCarCosts bietet eine Plattform zur Verfolgung von Fahrzeugausgaben, Wartungsmanagement und Finanzanalyse. Dies umfasst KI-gestützte Belegerkennung und Datenvisualisierungstools.",
            },
            responsibilities: {
                title: "3. Verantwortlichkeiten des Nutzers",
                description: "Sie sind für die Richtigkeit aller von Ihnen eingegebenen Daten verantwortlich, einschließlich Kilometerstand, Fahrgestellnummern (VIN) und Kosten. Sie müssen Ihre Zugangsdaten sicher aufbewahren.",
            },
            plans: {
                title: "4. Servicepläne und Limits",
                description: "Wir bieten kostenlose und Pro-Pläne mit unterschiedlichen Speicher-, Fahrzeuganzahl- und Upload-Limits an. Wir behalten uns das Recht vor, diese Limits jederzeit zu ändern.",
            },
            disclaimer: {
                title: "5. Haftungsausschluss und Genauigkeit",
                description: "MyCarCosts ist ein Informations- und Organisationswerkzeug. Wir stellen keine offiziellen Fahrzeugzustandsbescheinigungen aus. KI-generierte Daten sollten immer vom Nutzer überprüft werden.",
            },
            liability: {
                title: "6. Haftungsbeschränkung",
                description: "MyCarCosts wird 'wie besehen' bereitgestellt. Wir haften nicht für mechanische Probleme, finanzielle Verluste oder Datenungenauigkeiten, die aus der Nutzung unserer Anwendung resultieren.",
            },
            termination: {
                title: "7. Kündigung",
                description: "Sie können die Nutzung des Dienstes jederzeit beenden und Ihre Daten löschen. Wir behalten uns das Recht vor, Konten bei Verstößen gegen diese Bedingungen zu sperren oder zu kündigen.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

